<div class="content-wrapper">
  <div class="d-flex flex-row justify-content-between pb-16px">
    <h3 class="mb-16px">{{ this.dealerStore.name }} {{ this.dealerStore.bpNo }} / {{ this.dealerStore.address.city }}
      , {{ this.dealerStore.address.state }}</h3>
    <div class="d-flex flex-row">
      <div class="mr-8px">{{ productList.length || 0 }} Rows</div>
      <font-awesome (click)="changeView.emit(false)" [icon]="'fa-light fa-grid-2 btn-cursor'"></font-awesome>
    </div>
  </div>
  <div class="d-flex flex-column">
    <perfect-scrollbar [style.height]="'800px'">
      <div *ngFor="let product of productList;" class="d-flex bd-highlight products-box p-24px mb-24px">
        <div class="bd-highlight">
          <div class="item-img">
            <img [src]="product.modelImageUrl" alt="samsung products image" class="products-img">
          </div>
          <button (click)="removeProduct(product)" class="btn btn-products-outline mt-24px" type="button-outline">Remove
            Product
          </button>
        </div>
        <div class="bd-highlight flex-column ml-24px">
          <div class="products-title">{{ product.productName }}</div>
          <div class="d-flex flex-row mt-8px">
            <div class="number-label mr-8px">MODEL NUMBER</div>
            <div class="number-value">{{ product.modelCode }}</div>
            <div class="number-label ml-40px mr-8px">SERIAL NUMBER</div>
            <div class="number-value">{{ product.serialNo }}</div>
          </div>
          <div class="number-value mt-8px">Manufacturer Warranty Valid
            Through {{ product.warrantyTerm === 'P' ? product.partValidDateTo : product.laborValidDateTo }}
          </div>
        </div>
        <div class="ms-auto bd-highlight d-flex">
          <div class="flex-column d-flex justify-content-end">
            <button (click)="requestService(product)" *ngIf="showCreateTicketButton"
                    class="btn btn-products-solid align-items-end"
                    type="button-solid">
              Request Service
            </button>
            <button (click)="repairHistory(product)" *ngIf="showCreateTicketButton"
                    class="btn btn-products-outline align-items-end mt-24px" type="button-outline">
              Repair History
            </button>
          </div>
        </div>
      </div>
    </perfect-scrollbar>
  </div>
  <div *ngIf="!productList.length" class="align-center">
    <app-no-result-table [totalItems]="productList.length" [type]="'no-result-found'"></app-no-result-table>
    <!--<font-awesome [icon]="'fa-light fa-file-circle-exclamation'"></font-awesome>
    <span class="pl-14px">
      <ng-container *ngSwitchCase="'no-result-found'">
          No results found
      </ng-container>
    </span>-->
  </div>
</div>


